import callcenterEdit from './edit.vue'
import callcenterList from './list.vue'
import CallSeatsEdit from './callseats.vue'
import callConfigList from './callconfig.vue'
import callConfigEdit from './callconfigEdit.vue'

let a = Object.assign({ callcenterEdit, callcenterList,CallSeatsEdit,callConfigList,callConfigEdit},)
export default a
